<shared-toolbar title="Temas">
  @if (!isrole) {
    <mat-form-field subscriptSizing="dynamic" appearance="outline">
      <mat-label>Empresas</mat-label>
      <input
        type="text"
        aria-label="text"
        matInput
        [(ngModel)]="selectedBussinesName"
        [formControl]="myControl"
        [disabled]="!ValidBusiness_id()"
        [matAutocomplete]="auto"
        (keydown)="onKeyDown($event)" />
      <mat-autocomplete
        autoActiveFirstOption
        #auto="matAutocomplete"
        (optionSelected)="
          onOptionSelected($event.option.value, $event.option.viewValue)
        "
        (optionSelected)="loadThemes()">
        <mat-option [value]="null">- Temas Predeterminados - </mat-option>
        @for (option of filteredOptions | async; track option) {
          <mat-option [value]="option.idBusiness">{{ option.name }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  } @else {
    <mat-form-field subscriptSizing="dynamic" appearance="outline">
      <mat-label>Empresas</mat-label>
      <mat-select
        [disabled]="!ValidBusiness_id()"
        (selectionChange)="loadThemes()"
        [(value)]="selectedBussines">
        <mat-option [value]="null">- Temas Predeterminados - </mat-option>
        @for (item of bussines; track item) {
          <mat-option [value]="item.idBusiness">{{ item.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }

  <shared-search-field (inputValue)="fielInput = $event" [data]="dataSource" />
  @if (!this.selectedBussines) {
    <shared-button
      (click)="modalTheme()"
      [typeBtn]="'button'"
      [color]="'accent'"
      [icon]="'add'"
      >Agregar
    </shared-button>
  }
</shared-toolbar>
<mat-card class="mt-4 p-0 overflow-hidden">
  <mat-card-content class="overflow-y-hidden overflow-x-scroll">
    <table mat-table [dataSource]="dataSource" matSort>
      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>

      <!-- title Column -->
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Títulos de módulos
        </th>
        <td mat-cell *matCellDef="let element">
          <div
            class="circle p-2 w-100 h-100 border-white"
            [style.background-color]="element.title"></div>
        </td>
      </ng-container>

      <ng-container matColumnDef="primary">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Fondo de barra superior
        </th>
        <td mat-cell *matCellDef="let element">
          <div
            class="circle p-2 w-100 h-100 border-white"
            [style.background-color]="element.primary"></div>
        </td>
      </ng-container>

      <ng-container matColumnDef="accent">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Iconos de barra lateral
        </th>
        <td mat-cell *matCellDef="let element">
          <div
            class="circle p-2 w-100 h-100 border-white"
            [style.background-color]="element.accent"></div>
        </td>
      </ng-container>

      <ng-container matColumnDef="warn">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Botones</th>
        <td mat-cell *matCellDef="let element">
          <div
            class="circle p-2 w-100 h-100 border-white"
            [style.background-color]="element.warn"></div>
        </td>
      </ng-container>

      <ng-container matColumnDef="general">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Letras de los módulos
        </th>
        <td mat-cell *matCellDef="let element">
          <div
            class="circle p-2 w-100 h-100 border-white"
            [style.background-color]="element.general"></div>
        </td>
      </ng-container>

      <ng-container matColumnDef="itemNavbar">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Ítems de la barra superior
        </th>
        <td mat-cell *matCellDef="let element">
          <div
            class="circle p-2 w-100 h-100 border-white"
            [style.background-color]="element.itemNavBar"></div>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button
            mat-icon-button
            color="accent"
            [matMenuTriggerFor]="menu"
            aria-label="Mas opciones">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <a mat-menu-item (click)="modalTheme(element)">
              <mat-icon mat-icon-button>edit</mat-icon>
              <span>Editar</span>
            </a>
            @if (this.selectedBussines) {
              <a mat-menu-item (click)="modalChangeLogo()">
                <mat-icon mat-icon-button>folder_managed</mat-icon>
                <span>Editar Logotipo</span>
              </a>
            }
            @if (!this.selectedBussines) {
              <a mat-menu-item (click)="modalDelete(element)">
                <mat-icon mat-icon-button color="warn">delete</mat-icon>
                <span>Eliminar</span>
              </a>
            }
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">
          No hay resultados para la busqueda: {{ fielInput }}
        </td>
      </tr>
    </table>
    <br />
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
    </mat-paginator>
  </mat-card-content>
</mat-card>
